window.ExperienceForm = function (scope, userId, googleMaps, positionsDataService) {
    var self = this;
    var formName = "experience-form";
    self.name = formName;
    self.status = {loading: true, completed: true};
    self.showExperience = false;
    var _protected = BaseForm.call(self, formName, scope);

    var experienceToDelete = [];

    positionsDataService.getSystemPositionsFlat().then(function (positions) {
        self.data.positions = positions;
    });

    self.loading = true;
    self.TYPES = {
        JOB_APPLICATION: 'job_application',
        SETTINGS_WORK_HISTORY: 'SETTINGS_WORK_HISTORY',
    };

    self.isSettingsForm = function () {
        return self.type === self.TYPES.SETTINGS_WORK_HISTORY;
    };

    self.isJobApplicationForm = function () {
        return self.type === self.TYPES.JOB_APPLICATION;
    };


    self.data.experience = [{}];
    self.isCutsomPosition = [{}];

    self.addCustomPosition = function (index) {
        self.isCutsomPosition[index] = true;
        delete self.data.experience[index].position;
    };

    self.closeCustomPosition = function (index) {
        self.isCutsomPosition[index] = false;
        delete self.data.experience[index].position;
    };

    self.load = function () {

        var defer = $q.defer();

        self.data.firstJob = true;
        self.loading = true;
        SettingsAPI.loadUserExperience()
            .then(function (data) {

                self.data.experience = [];

                self.data.firstJob = data.first_job || false;

                if (!self.data.firstJob && data.length > 0) {
                    data.forEach(function (experience, index) {
                        experience.Brand && (experience.Brand['label'] = experience.Brand.name);

                        var object = {
                            'id': experience.id,
                            'brand': experience.Brand,
                            'phone': experience.phone,
                            'position': {},
                            'supervisor': experience.supervisor,
                            'allow_to_contact_reference': experience.allow_to_contact_reference ? "yes" : "no",
                            'reason_for_leaving': experience.reason_for_leaving,
                            'description': experience.description,
                            'start_date': experience.start_date,
                            'end_date': experience.end_date,
                            'still_work_here': (experience.end_date) ? false : true
                        };

                        if (experience.custom_position) {
                            object.position.custom_position = experience.custom_position;
                            self.isCutsomPosition[index] = true;
                        } else {
                            object.position = experience.Position;
                        }

                        self.data.experience.push(object);
                    });


                }
                else {
                    self.data.experience.push({});
                }

                self.status.loading = false;
                self.loading = false;
                self.data = angular.copy(self.data);
                self.calculateCompletness();
                defer.resolve();
            });

        return defer.promise;
    };


    self.save = function () {
        let defer = $q.defer();

        if (Object.keys(self.data.experience[0]).length || self.data.firstJob) {
            SettingsAPI.addUserExperience(self.data.experience, self.data.firstJob, experienceToDelete, self.isJobApplicationForm())
                .then(
                    (res) => {
                        if (res?.add?.data?.data) {
                            for (let i in res.add.data.data) {
                                for (let j in self.data.experience) {
                                    if (!self.data.experience[j].id) {
                                        self.data.experience[j].id = res.add.data.data[i].id;
                                        break;
                                    }
                                }
                            }
                        }

                        defer.resolve(res);
                        experienceToDelete = [];
                    },
                    (err) => {
                        defer.reject(err);
                    });

        } else {
            defer.resolve({});
        }
        return defer.promise;
    };

    self.deleteExperience = function (index) {

        index = index || 0;

        self.validator.clearValidate(index);

        if (self.data.experience[index] && self.data.experience[index].id) {
            experienceToDelete.push(self.data.experience[index].id);
        }

        self.data.experience.splice(index, 1);

        if (self.data.experience.length == 0) {
            self.data.experience.push({});
            if (self.isJobApplicationForm()){
                self.showExperience = false;
            }
        }

        self.calculateCompletness();
    };

    self.validator.afterValidation(function () {
        self.calculateCompletness();
    });

    self.calculateCompletness = function () {

        if (!self.data.firstJob) {

            var checkInterval;

            checkInterval = setInterval(function () {
                if ($("form." + formName + " [validate-rule]").length) {
                    self.status.completed = self.validator.validateWithoutError();

                    try {
                        scope.$digest();
                    }
                    catch (e) { /* Do Nothing */
                    }

                    clearInterval(checkInterval);
                }

            }, 500);
        }
        else {
            self.status.completed = true;
        }

        try {
            scope.$digest();
        }
        catch (e) { /* Do Nothing */
        }
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var fieldIndex = optionsField.attr('validate-index');

        switch (rule.name) {
            case 'date_range':
                if (self.data.experience[fieldIndex] && self.data.experience[fieldIndex].start_date && self.data.experience[fieldIndex].end_date) {
                    var start_date = new Date(self.data.experience[fieldIndex].start_date);
                    var end_date = new Date(self.data.experience[fieldIndex].end_date);

                    if (start_date.getTime() >= end_date.getTime() && !self.data.experience[fieldIndex]["still_work_here"]) {
                        return false;
                    }
                }

                break;

            case 'required_if_not':

                var dependency = rule.params[0];

                if (self.data.experience[fieldIndex] && !self.data.experience[fieldIndex][dependency] && !self.validator.getFieldValue(field)) {
                    return false;
                }

                return true;
                break;

            case 'required_if':

                var dependency = rule.params[0];

                if (!self.validator.getFieldValue(field) || (self.data.experience[fieldIndex] && !self.data.experience[fieldIndex][dependency] && !self.data.experience[fieldIndex]["still_work_here"])) {
                    return false;
                }

                break;

            case 'missing_required_fields':
                if (!self.data.firstJob && !self.showExperience) {
                    return false;
                }
                break;
        }

        return true;
    };

    self.addNewExperience = () => {
        if (self.isJobApplicationForm() && !self.showExperience) {
            self.showExperience = true;
            if (self.validator?.validation?.first_job) {
                self.validator.validation['first_job'].errors = {};
            }
        } else {
            self.data.experience.push({});
            self.calculateCompletness();
        }
    };

    self.parseWorkHistory = function (workHistory) {
	    var work_history = [];
	    if (!self.data.firstJob) {
		    for (var i in workHistory) {
		    	if (!_.isEmpty(workHistory[i])) {
				    var experience = {
					    brand: {
						    brand_name: Utils.capitalize(workHistory[i].employer) || '',
						    label: Utils.capitalize(workHistory[i].employer) || ''
					    },
					    description: workHistory[i].responsibilities || '',
					    start_date: workHistory[i].start_date || '',
					    position: {},
					    still_work_here: workHistory[i].present_job || false
				    };
				    if (workHistory[i].end_date && moment().diff(workHistory[i].end_date, 'days') > -1 && !experience.still_work_here) {
					    experience.end_date = workHistory[i].end_date;
				    }
				    if (workHistory[i].position) {
					    experience.position = workHistory[i].position;
				    }
				    else if (workHistory[i].user_position) {
					    experience.position = {
						    custom_position: Utils.capitalize(workHistory[i].user_position)
					    }
                        self.isCutsomPosition[i] = true;
				    }
				    work_history.push(experience);
			    }
		    }

		    if (work_history.length) {
			    self.data.experience = work_history;
			    self.showExperience = true;
		    }
	    }
    };

};
